import { channel } from 'redux-saga'
import { all, put, spawn, take } from 'typed-redux-saga'
import { Action } from 'redux'

import { ordersSaga } from 'Pages/orders'
import { companySaga, partnerAddressesSaga } from 'Pages/company'
import { knowledgeSaga } from 'Pages/knowledge'
import { ppSaga } from 'Pages/pp'
import { somSaga } from 'Pages/som'
import { actsSagas } from 'Pages/acts'
import { sagas as survey } from 'Pages/survey'
import { referenceBooksSaga } from 'Pages/referenceBooks'
import { iBroSaga } from 'Pages/ibro'
import { profileOrganizationSaga } from 'Pages/profileOrganization'
import { chatSaga } from 'Pages/chat'
import { advertisementSagas } from 'Pages/advertisement/store/sagas'
import { partnerSaga as smsPartnerSaga } from 'Pages/smsExpansion'
import { departmentSaga } from 'Pages/departments'
import { partnerRequestSaga } from 'src/pages/partnerRequests'
import { partnerProfileSaga } from 'Pages/partnerProfile'
import { profileSaga, userDocumentsSaga } from 'Pages/profile'
import { adminSagas } from 'Pages/admin'
import { moduleSaga } from 'Modules'
import { logsSaga } from 'Pages/logs'
import { registratorCabinetSagas } from 'Pages/registratorCabinet'
import { preloginSaga } from 'Pages/prelogin'
import { leadSaga } from 'Pages/lead'
import { userSaga } from 'Pages/user'

import { archiveBrokerSaga } from 'Pages/archiveBroker'
import { coliseumSagas } from 'Pages/coliseum'
import { authSaga } from 'Pages/auth'
import { registryBusinessAccessSaga } from 'Pages/registry_business_access_neo'
import { partnerSaga } from 'Pages/partner'
import { interfaceElementSaga } from 'Pages/interfaceElement'
import { dashboardSaga } from 'Pages/dashboard'
import { bankEmployeesSaga } from 'Pages/bankEmployees'
import { ordersDesignSaga } from 'Pages/orders_design'

export const sagaCallbackChannel = channel<Action<unknown>>()
function* sagaCallbackChannelWatcher() {
	while (true) {
		const action = yield* take(sagaCallbackChannel)
		yield* put(action)
	}
}

export function* rootSaga() {
	yield* spawn(sagaCallbackChannelWatcher)
	yield* spawn(adminSagas)
	yield* spawn(departmentSaga)
	yield* spawn(partnerRequestSaga)
	yield* spawn(profileSaga)
	yield* spawn(userDocumentsSaga)
	yield* spawn(logsSaga)
	yield* spawn(iBroSaga)
	yield* spawn(archiveBrokerSaga)
	yield* spawn(chatSaga)
	yield* spawn(registryBusinessAccessSaga)
	yield* spawn(smsPartnerSaga)
	yield* spawn(profileOrganizationSaga)
	yield* spawn(ordersSaga)
	yield* spawn(moduleSaga)
	yield* spawn(companySaga)
	yield* spawn(partnerProfileSaga)
	yield* spawn(preloginSaga)
	yield* spawn(coliseumSagas)
	yield* spawn(referenceBooksSaga)
	yield* spawn(registratorCabinetSagas)
	yield* spawn(somSaga)
	yield* spawn(authSaga)
	yield* spawn(leadSaga)
	yield* spawn(ppSaga)
	yield* spawn(partnerSaga)
	yield* spawn(knowledgeSaga)
	yield* spawn(interfaceElementSaga)
	yield* spawn(dashboardSaga)
	yield* spawn(userSaga)
	yield* spawn(bankEmployeesSaga)
	yield* spawn(partnerAddressesSaga)

	yield* all([...actsSagas, ...survey, ...ordersDesignSaga, ...advertisementSagas])
}
